<template>
  <section
    :class="[
      'double-image',
      `double-image--${data.orientation}`,
    ]"
  >
    <div class="c-container">
      <AppPicture
        class="double-image__picture"
        :data="{ url: data.imageLeft }"
        :data-hover="data.imageLeftAlt"
      />
      <AppPicture
        class="double-image__picture"
        :data="{ url: data.imageRight }"
        :data-hover="data.imageRightAlt"
      />
    </div>
  </section>
</template>

<script>
import AppPicture from '@/components/AppPicture.vue';

export default {
  name: 'doubleImage',

  components: {
    AppPicture,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~sass-mq/mq";
@import '../style/variables';
@import '../style/mixins';

.double-image {
  .c-container {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    flex-flow: row wrap;
  }

  &__picture::after {
    content: attr(data-hover);

    position: absolute;
    bottom: -40px;
    left: 20px;
    max-width: 350px;
  }

  .double-image__picture {
    width: 100%;
    flex: 0 0 100%;

    @include mq(ipadP) {
      width: calc(70% - 120px);
      flex: 0 0 calc(70% - 120px);
    }

    @include aspect-ratio(4, 3);

    @include mq($and: $is-not-touch-device) {
      &::after {
        opacity: 0;
        transition: opacity 0.3s ease-out;
      }

      &:hover::after {
        opacity: 1
      }
    }
  }

  &.double-image--left .double-image__picture:first-child,
  &.double-image--right .double-image__picture:last-child {
    width: 100%;
    flex: 0 0 100%;
    margin-bottom: 60px;

    @include mq(ipadP) {
      width: 30%;
      flex: 0 0 30%;
    }

    @include aspect-ratio(3, 4);
  }
}
</style>
